// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CHAUFFEURS = "GET_CHAUFFEURS";

// Add CHAUFFEUR
export const ADD_NEW_CHAUFFEUR = "ADD_NEW_CHAUFFEUR";
export const ADD_CHAUFFEUR_SUCCESS = "ADD_CHAUFFEUR_SUCCESS";
export const ADD_CHAUFFEUR_FAIL = "ADD_CHAUFFEUR_FAIL";

// Edit CHAUFFEUR
export const UPDATE_CHAUFFEUR = "UPDATE_CHAUFFEUR";
export const UPDATE_CHAUFFEUR_SUCCESS = "UPDATE_CHAUFFEUR_SUCCESS";
export const UPDATE_CHAUFFEUR_FAIL = "UPDATE_CHAUFFEUR_FAIL";
